import { Injectable } from '@angular/core';
import { Board, Card, List, Tag } from '../models/board.model';

@Injectable()

export class BoardService {

  constructor() { }

  private data: Board = [];

  setBoard(board: Board) {
    this.data = board;
  }

  updateTags(_list: List, _card: Card, tags: Tag[]) {
    let list = this.data.find(list => list.id == _list.id);
    let card = list!.cards.find(card => card.id == _card.id);
    let index = list!.cards.indexOf(card as Card);
    this.data[this.data.indexOf(_list)].cards[index].tags = tags;
  }

  updateAlert(_list: List, _card: Card) {
    let list = this.data.find(list => list.id == _list.id);
    let card = list!.cards.find(card => card.id == _card.id);
    let index = list!.cards.indexOf(card as Card);
    this.data[this.data.indexOf(_list)].cards[index].alerta = 0;
  }

  deleteCard(listId: Number, cardId: Number): void {
    let list = this.data.find(list => list.id == listId);
    let card = list!.cards.find(card => card.id == cardId);
    let index = list!.cards.indexOf(card as Card);
    list!.cards.splice(index, 1);
  }

  addList(id: number, listName: string): void {
    this.data.push({ 'id': id, 'name': listName, delete: true, rename: true, renaming: false, 'cards': [] });
  }

  deleteList(listId: Number): void {
    let list = this.data.find(list => list.id == listId);
    let index = this.data.indexOf(list as any);
    this.data.splice(index, 1);
  }

}
